import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Select,
    MenuItem,
    Button,
    Snackbar,
    Alert,
    Typography,
    Box,
} from "@mui/material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { useNavigate } from "react-router-dom";

import "./AddUserDialog.css";
import API_ENDPOINTS from "../../apis/endpoints";
import useAuth from "../../context";

function AddUserDialog({ open, onClose }) {
    const auth = useAuth();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: "",
        userType: "",
    });
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleAddUser = async (e) => {
        e.preventDefault();

        const storedDeviceId = localStorage.getItem("device-id");

        let sendData = new FormData();
        sendData.append("email", formData.email);
        sendData.append("role", formData.userType);

        try {
            const response = await fetch(`${API_ENDPOINTS.ADMIN_USER}`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${auth.accessToken}`,
                    "x-cc-device-id": storedDeviceId,
                },
                body: sendData,
            });

            const json = await response.json();

            if (!json.success) {
                throw new Error(json.message);
            }

            if (response.ok) {
                setSnackbar({
                    open: true,
                    message: "User added successfully",
                    severity: "success",
                });
                onClose();
                // Optionally, you can refresh the user list here
            }
        } catch (error) {
            console.log(error, "error");
            setSnackbar({
                open: true,
                message: error.message,
                severity: "error",
            });
        }
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setSnackbar({ ...snackbar, open: false });
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                className="add-user-dialog"
                PaperProps={{
                    style: {
                        width: "100%",
                        maxWidth: "600px",
                        margin: "auto",
                    },
                }}
            >
                <DialogTitle className="add-user-dialog-title">
                    <Box display="flex" alignItems="center">
                        <PersonAddIcon className="add-user-icon" />
                        <Typography variant="h6">Add New User</Typography>
                    </Box>
                </DialogTitle>
                <DialogContent className="add-user-dialog-content">
                    <form onSubmit={handleAddUser} className="add-user-form">
                        <TextField
                            className="add-user-input"
                            fullWidth
                            type="email"
                            name="email"
                            label="Email Address"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                            variant="outlined"
                        />
                        <Select
                            className="add-user-select"
                            fullWidth
                            name="userType"
                            value={formData.userType}
                            onChange={handleInputChange}
                            required
                            variant="outlined"
                            displayEmpty
                        >
                            <MenuItem value="" disabled>
                                Select User Type
                            </MenuItem>
                            <MenuItem value="admin">Admin</MenuItem>
                            <MenuItem value="agent">Agent</MenuItem>
                            <MenuItem value="talent">Talent</MenuItem>
                            <MenuItem value="executive_admin">
                                Executive Admin
                            </MenuItem>
                        </Select>
                    </form>
                </DialogContent>
                <DialogActions className="add-user-dialog-actions">
                    <Button onClick={onClose} color="primary">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleAddUser}
                        variant="contained"
                        className="add-user-button"
                    >
                        Add User
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={snackbar.severity}
                    sx={{ width: "100%" }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
}

export default AddUserDialog;
